import React from 'react';
import PropTypes from 'prop-types';
import { openMtgChat } from 'utils';
import { Container, Column, ColumnTitle, Link } from './styles';
import { useRouter } from 'next/router';
import { useAuthUser } from 'features/auth/AuthUserContext';

const Props = {
  tasksLinks: PropTypes.arrayOf(
    PropTypes.shape({
      external: PropTypes.bool,
      href: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  resourcesLinks: PropTypes.arrayOf(
    PropTypes.shape({
      external: PropTypes.bool,
      href: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
};

export default function OverviewLinks({ tasksLinks, resourcesLinks }) {
  const router = useRouter();
  const { user } = useAuthUser();
  const showCookieButton = [
    'BR',
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'GB',
  ].includes(user.country_code);

  function redirect(event, path) {
    event.preventDefault();
    router.push(path);
  }

  return (
    <Container>
      <Column>
        <ColumnTitle>Common tasks</ColumnTitle>
        {tasksLinks.map((link) => (
          <Link
            onClick={!link.external ? (event) => redirect(event, link.href) : null}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            key={link.label}
          >
            {link.label}
          </Link>
        ))}
      </Column>

      <Column>
        <ColumnTitle>Helpful resources</ColumnTitle>
        {resourcesLinks.map((link) => (
          <Link
            onClick={!link.external ? (event) => redirect(event, link.href) : null}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            key={link.label}
          >
            {link.label}
          </Link>
        ))}

        <Link onClick={openMtgChat}>Contact Us</Link>

        {showCookieButton && (
          <Link onClick={() => launchModifyConsentPopup()}>Cookie Preferences</Link>
        )}
      </Column>
    </Container>
  );
}

OverviewLinks.propTypes = Props;
